module.exports = __webpack_public_path__ + "static/media/YM46_7.55f6c035.jpg";